import { render, staticRenderFns } from "./modal-why-use-oc.vue?vue&type=template&id=21865ec2"
import script from "./modal-why-use-oc.vue?vue&type=script&lang=js"
export * from "./modal-why-use-oc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports